module.exports = __webpack_public_path__ + "img/1557614110471954435.843799a7.png";